import React from "react";
import "./footer.css";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

const Footer = () => {
  return (
    <div id="contact">
      <footer>
        <div className="footer">
          <div className="summary">
            <h2>
              <a href="" className="a-logo">
                R.M{" "}
              </a>
            </h2>
            <p>
              I am an architectural designer with great experience in web-design
              and web development. I have worked on various projects that
              include website design, e-commerce sites and other web apps. I
              have also worked on various projects related to 3D modeling,
              detailing and project management.{" "}
            </p>
            <div className="icons"></div>
          </div>
          <div className="Company">
            <h2>Links</h2>
            <ul>
              <li>Projects</li>
              <li>Services</li>
              <li id="contact">Contact</li>
            </ul>
          </div>
          <div className="Our-focus">
            <h2 className="our">
              <span className="bnb"> Contact</span>
            </h2>
            <ul>
              <li>roymasai001<br></br>@gmail.com</li>
              <li>0728300345</li>
            </ul>
          </div>
          <div className="Others">
            <h2>Others</h2>
            <ul>
              <li>FAQs</li>
              <li>Terms of Services</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
        <h2 className="footer-center">
          All rights reserved, terms & conditions applied.
        </h2>
      </footer>
    </div>
  );
};

export default Footer;
